<impersonationBanner></impersonationBanner>

<header
  class="sticky top-0 z-50 flex w-full border-gray-200 bg-white border-b dark:border-gray-800 dark:bg-gray-900"
  [class.h-22]="layoutService.isDesktop()"
  [class.h-auto]="!layoutService.isDesktop()"
>
  <div
    id="header"
    class="flex grow items-center justify-end justify-between lg:px-6"
  >

    @if(layoutService.isDesktop()) {

<!--      DESKTOP-->

      <div
        class="flex gap-2 px-3 py-3 !pl-0 sm:gap-4 lg:justify-normal lg:border-b-0 lg:px-0 lg:py-4 dark:border-gray-800"
      >

        <button
          [pTooltip]="(layoutService.isMenuCollapsed() ? 'Restaurer le menu' : 'Minimiser le menu')"
          type="button"
          #menuToggleDesktop
          id="menuToggleDesktop"
          (click)="layoutService.toggleDesktopMenu()"
          class="flex h-10 w-10 items-center justify-center rounded-lg border-none text-gray-500 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        >
          <i [class]="layoutService.isMenuCollapsed() ? 'fa-light fa-right-to-line' : 'fa-light fa-left-to-line'"></i>
        </button>
        <button
          [pTooltip]="'Passage en plein écran'"
          (click)="layoutService.isFullscreen() ? layoutService.closeFullscreen() : layoutService.openFullscreen()"
          class="flex h-10 w-10 items-center justify-center rounded-lg border-none text-gray-500 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
        >
          <i [class]="layoutService.isFullscreen() ? 'fa-light fa-minimize' : 'fa-light fa-maximize'"></i>
        </button>


      </div>


      <div
        class="w-full items-center justify-end gap-4 flex"
        [class.flex]="layoutService.isDesktop()"
        [class.hidden]="!layoutService.isDesktop()"
      >
        <!-- User Area -->

        <div
          class="relative gap-4"
        >

          <p-toolbar class="border-none p-0">
            <ng-template #start>
              <div class="items-center gap-2 md:flex hidden">

                <!-- ╔═══════════════════════════════════════════════════════════ ╗
                     ║  ZONE NOTIFICATIONS — pill container avec séparateurs    ║
                     ╚═══════════════════════════════════════════════════════════ ╝ -->
                <div class="flex items-center gap-0.5 rounded-full border border-gray-200 bg-white p-0.5 shadow-sm dark:border-gray-700 dark:bg-gray-800">

                  <!-- Notif factures (admin + accessEbuiz) -->
                  @if(user && user?.accessEbuiz === 1){
                    <p-overlayBadge
                      [value]="(facturesFacturationAlertes?.factures?.length || 0)"
                      class="badge-sm z-9999"
                      [badgeSize]="'small'"
                      severity="danger">
                      <button type="button"
                              [pTooltip]="'Rappels auto facturation'|transloco"
                              tooltipPosition="bottom"
                              (click)="opFactures.toggle($event)"
                              class="flex h-11 w-11 items-center justify-center rounded-full text-amber-600 hover:bg-amber-50 transition-colors dark:hover:bg-amber-900/30">
                        <i class="fa-light fa-file-invoice-dollar text-xl"></i>
                      </button>
                    </p-overlayBadge>
                    <p-popover #opFactures>
                      <div class="w-80 max-w-sm">
                        <div class="flex items-center justify-between px-3 py-2.5 bg-gradient-to-br from-amber-50 to-orange-50 border-b border-amber-100 dark:from-amber-900/20 dark:to-orange-900/20 dark:border-amber-800">
                          <div class="flex items-center gap-2">
                            <i class="fa-light fa-file-invoice-dollar text-amber-700"></i>
                            <h6 class="text-sm font-semibold text-amber-800 dark:text-amber-200 m-0">
                              {{ 'Rappels auto facturation'|transloco }}
                            </h6>
                          </div>
                          <span class="inline-flex items-center px-2 py-0.5 text-[11px] font-bold bg-white text-amber-700 rounded-full border border-amber-200 dark:bg-amber-900 dark:text-amber-200 dark:border-amber-700">
                            {{facturesFacturationAlertes?.factures?.length || 0}}
                          </span>
                        </div>

                        <div class="max-h-64 overflow-y-auto">
                          @for (facture of facturesFacturationAlertes?.factures; track facture) {
                            <div [routerLink]="['/eBusiness', 'factures','fiche',facture.id]"
                                 class="cursor-pointer px-3 py-2 border-b border-gray-100 hover:bg-amber-50/40 transition-colors dark:border-gray-700 dark:hover:bg-gray-800">
                              <div class="flex items-center gap-3">
                                <div class="w-8 h-8 rounded-full flex items-center justify-center bg-amber-50">
                                  <i class="fa-light fa-triangle-exclamation text-sm text-amber-600"></i>
                                </div>
                                <div class="flex-1 min-w-0">
                                  <div class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{facture?.client?.nom}}</div>
                                  <div class="text-xs text-gray-500 dark:text-gray-400">Facture N°{{facture?.numreal ? facture?.numreal : 'PR-' + facture?.num}}</div>
                                </div>
                              </div>
                            </div>
                          }
                          @if (!facturesFacturationAlertes?.factures?.length) {
                            <div class="p-4 text-center text-xs text-gray-400 italic">
                              {{ 'Aucun rappel'|transloco }}
                            </div>
                          }
                        </div>

                        <div class="px-3 py-2 bg-gray-50 border-t border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                          <a [routerLink]="['/eBusiness', 'alerte-delais']"
                             class="block text-center text-xs text-vge font-medium hover:underline">
                            {{ 'Voir le calendrier mensuel'|transloco }}
                          </a>
                        </div>
                      </div>
                    </p-popover>

                    <span class="w-px h-5 bg-gray-200 dark:bg-gray-700 mx-0.5"></span>
                  }

                  <!-- Notif événements + déclarations (réservé admin et +, pas pour les utilisateurs eGestion) -->
                  @if (user && ROLES.admin.indexOf(user?.profil?.name) > -1) {
                  <p-overlayBadge
                    [value]="events?.length + nbDeclarationsDay"
                    class="badge-sm z-9999"
                    [badgeSize]="'small'"
                    severity="danger">
                    <button type="button"
                            [pTooltip]="'Événements et déclarations'|transloco"
                            tooltipPosition="bottom"
                            (click)="opNotif.toggle($event)"
                            class="flex h-11 w-11 items-center justify-center rounded-full text-blue-600 hover:bg-blue-50 transition-colors dark:hover:bg-blue-900/30">
                      <i class="fa-light fa-envelope text-xl"></i>
                    </button>
                  </p-overlayBadge>
                  <p-popover #opNotif>
                    <div class="w-80 max-w-sm">
                      @if (user && showEvents === true && events?.length > 0) {
                        <div class="mb-2">
                          <div class="flex items-center justify-between px-3 py-2.5 bg-gradient-to-br from-blue-50 to-sky-50 border-b border-blue-100 dark:from-blue-900/20 dark:to-sky-900/20 dark:border-blue-800">
                            <div class="flex items-center gap-2">
                              <i class="fa-light fa-bell-on text-blue-700"></i>
                              <h6 class="text-sm font-semibold text-blue-800 dark:text-blue-200 m-0">
                                {{ 'Notifications Événements'|transloco }}
                              </h6>
                            </div>
                            <span class="inline-flex items-center px-2 py-0.5 text-[11px] font-bold bg-white text-blue-700 rounded-full border border-blue-200">{{events?.length}}</span>
                          </div>

                          <div class="max-h-64 overflow-y-auto" [ngClass]="{'max-h-80': (events?.length || 0) > 2}">
                            @for (event of events; track event) {
                              <div class="px-3 py-2 border-b border-gray-100 hover:bg-blue-50/40 transition-colors cursor-pointer dark:border-gray-700 dark:hover:bg-gray-800">
                                <eventAction [showPeopleTitle]="true" [padding]="false" [event]="event"></eventAction>
                              </div>
                            }
                          </div>

                          <div class="px-3 py-2 bg-gray-50 border-t border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                            <a [routerLink]="['/eBoarding', 'home']"
                               class="block text-center text-xs text-blue-600 hover:underline font-medium">
                              {{ 'Voir toutes les notifications'|transloco }}
                            </a>
                          </div>
                        </div>
                      }

                      @if (user && ROLES.admin.indexOf(user?.profil?.name) > -1) {
                        <div>
                          <div class="flex items-center justify-between px-3 py-2.5 bg-gradient-to-br from-orange-50 to-red-50 border-b border-orange-100 dark:from-orange-900/20 dark:to-red-900/20 dark:border-orange-800">
                            <div class="flex items-center gap-2">
                              <i class="fa-light fa-triangle-exclamation text-orange-700"></i>
                              <h6 class="text-sm font-semibold text-orange-800 dark:text-orange-200 m-0">
                                {{ 'Déclarations'|transloco }}
                              </h6>
                            </div>
                            <span class="inline-flex items-center px-2 py-0.5 text-[11px] font-bold bg-white text-orange-700 rounded-full border border-orange-200">{{nbDeclarationsDay}}</span>
                          </div>

                          <div class="max-h-64 overflow-y-auto">
                            @for (groupDeclaration of declarationsDay.declarations|keyvalue; track groupDeclaration) {
                              @if (groupDeclaration?.value && groupDeclaration.value['length'] > 0) {
                                @let group = groupDeclaration?.value;

                                <div class="border-b border-gray-100 dark:border-gray-700">
                                  <div class="flex items-center justify-between px-3 py-1.5 bg-gray-50/70 dark:bg-gray-800">
                                    <span class="text-xs font-semibold uppercase tracking-wide"
                                          [style.color]="getColor(groupDeclaration.key).primary">
                                      @if(groupDeclaration.key === 'L114') {
                                        {{'Déclarations L114'|transloco}}
                                      } @else {
                                        {{'Déclaration J+'|transloco}}{{groupDeclaration.key}}
                                      }
                                    </span>
                                    <span class="inline-flex items-center px-2 py-0.5 text-[10px] font-bold text-white rounded-full"
                                          [style.backgroundColor]="getColor(groupDeclaration.key).primary">
                                      {{group?.length}}
                                    </span>
                                  </div>

                                  <div class="divide-y divide-gray-100 dark:divide-gray-700">
                                    @for (declaration of group || []; track declaration) {
                                      @if (declaration && declaration.id && declaration.libelle && declaration.operation_id) {
                                        <a [routerLink]="['/DOnet', 'sinistre','fiche',declaration.id, declaration.operation_id]"
                                           class="flex items-center px-3 py-2 hover:bg-gray-50 transition-colors group dark:hover:bg-gray-800">
                                          <div class="flex-shrink-0 mr-3">
                                            <div class="w-8 h-8 rounded-full flex items-center justify-center"
                                                 [style.backgroundColor]="getColor(groupDeclaration.key).primary + '20'">
                                              <i class="fa-light fa-triangle-exclamation text-sm"
                                                 [style.color]="getColor(groupDeclaration.key).primary"></i>
                                            </div>
                                          </div>
                                          <div class="flex-1 min-w-0">
                                            <p class="text-sm font-medium text-gray-900 truncate group-hover:text-gray-700 dark:text-gray-100 m-0">{{declaration?.libelle}}</p>
                                            <p class="text-xs text-gray-500 truncate dark:text-gray-400 m-0">{{declaration?.referencevge}}</p>
                                          </div>
                                        </a>
                                      }
                                    }
                                  </div>
                                </div>
                              }
                            }
                          </div>
                          <div class="px-3 py-2 bg-gray-50 border-t border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                            <a [routerLink]="['/eBoarding', 'alerte-delais']"
                               class="block text-center text-xs text-vge font-medium hover:underline">
                              {{ 'Voir le calendrier mensuel'|transloco }}
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  </p-popover>
                  }

                  <!-- Notif rappels auto sinistres demain (admin uniquement,
                       et seulement si le tenant execute les rappels auto) -->
                  @if (rappelsAutoActifs && user && ROLES.admin.indexOf(user?.profil?.name) > -1) {
                    <span class="w-px h-5 bg-gray-200 dark:bg-gray-700 mx-0.5"></span>

                    <p-overlayBadge
                      [value]="nbRappelsTomorrow"
                      class="badge-sm z-9999"
                      [badgeSize]="'small'"
                      severity="warn">
                      <button type="button"
                              [pTooltip]="'Rappels auto à envoyer demain — clique pour vérifier'|transloco"
                              tooltipPosition="bottom"
                              (click)="refreshRappelsTomorrow(); opRappels.toggle($event)"
                              class="flex h-11 w-11 items-center justify-center rounded-full text-teal-700 hover:bg-teal-50 transition-colors dark:hover:bg-teal-900/30">
                        <i class="fa-light fa-bell-on text-xl"></i>
                      </button>
                    </p-overlayBadge>
                    <p-popover #opRappels>
                      <div class="w-80 max-w-sm">
                        <div class="flex items-center justify-between px-3 py-2.5 bg-gradient-to-br from-teal-50 to-emerald-50 border-b border-teal-100 dark:from-teal-900/20 dark:to-emerald-900/20 dark:border-teal-800">
                          <div class="flex items-center gap-2">
                            <i class="fa-light fa-bell text-teal-700"></i>
                            <h6 class="text-sm font-semibold text-teal-800 dark:text-teal-200 m-0">
                              {{ 'Rappels auto demain'|transloco }}
                            </h6>
                          </div>
                          <span class="inline-flex items-center px-2 py-0.5 text-[11px] font-bold bg-white text-teal-700 rounded-full border border-teal-200">{{nbRappelsTomorrow}}</span>
                        </div>

                        <div class="max-h-64 overflow-y-auto">
                          @for (entry of rappelsTomorrowEntries | slice:0:8; track entry.histoId) {
                            <a [routerLink]="['/DOnet', 'sinistre','fiche', entry.sinistreId, entry.operationId]"
                               class="flex items-start gap-3 px-3 py-2 border-b border-gray-100 hover:bg-teal-50/40 transition-colors dark:border-gray-700 dark:hover:bg-gray-800">
                              <div class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center mt-0.5"
                                   [style.backgroundColor]="(entry.etatSuiviCouleur || '#0d9488') + '20'">
                                <i class="fa-light fa-bell text-sm"
                                   [style.color]="entry.etatSuiviCouleur || '#0d9488'"></i>
                              </div>
                              <div class="flex-1 min-w-0">
                                <div class="text-sm font-medium text-gray-800 dark:text-gray-200 truncate">{{entry.referencevge}}</div>
                                <div class="text-xs text-gray-500 dark:text-gray-400 truncate">{{entry.operationLibelle}}</div>
                                @if (entry.etatSuiviLibelle) {
                                  <span class="inline-block mt-1 px-1.5 py-0 text-[10px] font-semibold text-white rounded-full"
                                        [style.backgroundColor]="entry.etatSuiviCouleur || '#0d9488'">
                                    {{entry.etatSuiviLibelle}}
                                  </span>
                                }
                              </div>
                            </a>
                          }
                          @if (!nbRappelsTomorrow) {
                            <div class="p-4 text-center text-xs text-gray-400 italic">
                              <i class="fa-light fa-circle-check text-emerald-500 mr-1"></i>
                              {{ 'Aucun rappel prévu demain'|transloco }}
                            </div>
                          }
                          @if (nbRappelsTomorrow > 8) {
                            <div class="px-3 py-1.5 text-center text-[11px] text-gray-500 italic bg-gray-50/70 dark:bg-gray-800">
                              + {{ nbRappelsTomorrow - 8 }} {{ 'autre(s)…'|transloco }}
                            </div>
                          }
                        </div>

                        <div class="px-3 py-2 bg-gray-50 border-t border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                          <a [routerLink]="['/Admin', 'rappels-auto-sinistres']"
                             class="block text-center text-xs text-teal-700 font-semibold hover:underline">
                            {{ 'Gérer les rappels auto'|transloco }}
                            <i class="fa-light fa-arrow-right ml-1"></i>
                          </a>
                        </div>
                      </div>
                    </p-popover>
                  }

                </div>
                <!-- ╚═══════════════════════════════════════════════════════════ ╝ -->



                <!-- Language -->

                @if (blockedToJ) {
                  <p-button
                    [label]="'J+'+JplusBlocked"
                    icon="fa-light fa-lock-alt"
                    [severity]="'info'"
                    [badge]="nbJBlocked+''"
                    size="small"
                    [badgeSeverity]="'warn'"
                    tooltipPosition="bottom"
                    (click)="openSlideJ()"
                    [pTooltip]="'Vous êtes bloqués car vous avez '+nbJBlocked+' dossiers sinistres non actualisés en J+'+JplusBlocked"
                  ></p-button>
                }

                @if (totalTTL > 0) {
                  <div class="hidden lg:flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
                    @if (btnrefrsh === true) {
                      <button
                        class="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                        pTooltip="Renouveler la session"
                        tooltipPosition="bottom"
                        (click)="makeCall()"
                      >
                        <i class="fa fa-light fa-arrow-rotate-right text-gray-600 dark:text-gray-400"></i>
                      </button>
                    }

                    <div class="flex align-items-center gap-2">
                      <i class="fa-light fa-hourglass-clock text-lg"
                         [pTooltip]="'Temps restant de la session actuelle'|transloco"
                         tooltipPosition="bottom"
                         [ngClass]="{
                         'text-green-500': (counter > totalTTL / 2 || totalTTL == 0),
                         'text-yellow-500': (counter < totalTTL / 2 && counter > totalTTL /4),
                         'text-red-500': (counter < totalTTL /4)
                       }">
                      </i>

                      <div class="text-sm font-medium font-mono"
                           [ngClass]="{
                           'text-green-600 dark:text-green-400': (counter > totalTTL / 2 || totalTTL == 0),
                           'text-yellow-600 dark:text-yellow-400': (counter < totalTTL / 2 && counter > totalTTL /4),
                           'text-red-600 dark:text-red-400': (counter < totalTTL /4)
                         }">
                        @if (counter > 0) {
                          <span>{{moment.utc(counter * 1000).format('mm:ss')}}</span>
                        }
                        @if (counter <= 0) {
                          <span class="text-red-600 dark:text-red-400 font-semibold animate-pulse">00:00</span>
                        }
                      </div>
                    </div>

                    <!-- Barre de progression -->
                    <div class="w-16 h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                      <div class="h-full transition-all duration-1000 ease-linear rounded-full"
                           [ngClass]="{
                           'bg-green-500': (counter > totalTTL / 2),
                           'bg-yellow-500': (counter < totalTTL / 2 && counter > totalTTL /4),
                           'bg-red-500': (counter < totalTTL /4)
                         }"
                           [style.width.%]="(counter / totalTTL) * 100">
                      </div>
                    </div>
                  </div>
                }

                <p-button (click)="langs.toggle($event)" class="" text severity="secondary">
                  <ng-template #icon>
                    <i class="fi fi-{{(allLanguages|find:'value':selectedLanguage).icon}}"></i>
                  </ng-template>
                </p-button>

                <p-popover #langs>
                  <ul class="w-48 text-sm font-medium text-gray-900 bg-white rounded-lg dark:bg-gray-700  dark:text-white">
                    @for(lang of allLanguages; track $index; let last = $last) {
                      <li [ngClass]="!last ? 'border-b' : ''" class="w-full px-4 py-2 border-gray-200 hover:bg-gray-100 dark:border-gray-600" (click)="changeLanguage(lang.value)"><a href="javascript:void(0)"><i [ngClass]="lang.icon"></i> {{lang.label|transloco}}</a></li>
                    }
                  </ul>
                </p-popover>

                <!--              <p-dropdown [options]="languages" [(ngModel)]="selectedLanguage" optionLabel="label" optionValue="value" (onChange)="changeLanguage($event.value)" class="hidden lg:block"></p-dropdown>-->
                <!-- End Language -->

              </div>
            </ng-template>
            <ng-template #end>
              <p-menubar class="border-none" [model]="items">
                <ng-template pTemplate="submenuicon">
                  <i [class]="menuExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                </ng-template>
                <ng-template pTemplate="start">
                  <div class="flex justify-between">
                    <p-overlay-badge value="" severity="success" class="online">
                      @if(user?.image){
                        <p-avatar image="{{user?.image|imgRsz:42:42}}" size="large" shape="circle"></p-avatar>
                      } @else {
                        <p-avatar class="select-none" label="{{user?.lastname?.[0] || ''}}{{user?.firstname?.[0] || ''}}" size="large" shape="circle"></p-avatar>
                      }

                    </p-overlay-badge>
                  </div>
                </ng-template>
              </p-menubar>
            </ng-template>
          </p-toolbar>

        </div>
        <!-- User Area -->
      </div>


    } @else {

<!--      Mobile-->

      <div
        class="flex lg:hidden items-center justify-between gap-2 border-b border-gray-200 px-3 py-3 !pl-0 sm:gap-4 lg:justify-normal lg:border-b-0 lg:px-0 lg:py-4 dark:border-gray-800"
        [class.w-full]="!layoutService.isDesktop()"
      >

        <button
          #menuToggleMobile
          id="menuToggleMobile"
          (click)="layoutService.toggleMobileMenu()"
          class="flex h-10 w-10 items-center justify-center rounded-lg border-gray-200 text-gray-500 lg:h-11 lg:w-11 lg:border dark:border-gray-800 dark:text-gray-400"
        >
          <svg
            class="fill-current"
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H14.5C15.0523 0 15.5 0.447715 15.5 1C15.5 1.55228 15.0523 2 14.5 2H1.5C0.947715 2 0.5 1.55228 0.5 1ZM0.5 6C0.5 5.44772 0.947715 5 1.5 5H14.5C15.0523 5 15.5 5.44772 15.5 6C15.5 6.55228 15.0523 7 14.5 7H1.5C0.947715 7 0.5 6.55228 0.5 6ZM1.5 10C0.947715 10 0.5 10.4477 0.5 11C0.5 11.5523 0.947715 12 1.5 12H14.5C15.0523 12 15.5 11.5523 15.5 11C15.5 10.4477 15.0523 10 14.5 10H1.5Z"
            />
          </svg>
        </button>

        <a [routerLink]="['/dashboard']">
          <app-logo></app-logo>
        </a>

        <!-- User Menu Mobile -->
        <button
          id="openMenuUserMobile"
          #openMenuUserMobile
          class="z-99999 flex h-10 w-10 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 lg:hidden dark:text-gray-400 dark:hover:bg-gray-800"
        >
          <!-- SVG content -->
        </button>

      </div>

      <!-- Mobile Menu Drawer -->
      <p-drawer
        [(visible)]="visible"
        styleClass="!w-full sm:!w-80"
        (onHide)="layoutService.closeMobileMenu()"
      >
        <app-menu (clicked)="layoutService.closeMobileMenu()"></app-menu>
      </p-drawer>

    }


    <!-- Desktop User Area -->

  </div>
</header>
